import React, { useEffect } from "react";
import './footer.css';
import { GoLaw } from "react-icons/go";
import { ImFacebook } from "react-icons/im";
import { BsLinkedin } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import Aos from 'aos';
import 'aos/dist/aos.css';

const Footer = () => {

  useEffect(() => {
    Aos.init({ duration: 2000, once: true })
    Aos.refresh();
    window.addEventListener('load', Aos.refresh);
  }, [])

  return (
    <div className="footer">
      <div className="secContainer container grid">
        <div data-aos="fade-up" data-aos-duration="2000" className="logoDiv">
          <div data-aos="fade-up" data-aos-duration="2000" className="footerLogo">
            <a href="#" className="logo flex">
              <h1 className="flex">
                <GoLaw className="icon" />
                LegalNable</h1>
            </a>
          </div>

          <div data-aos="fade-up" data-aos-duration="3000" className="socials flex">
            <a href="https://www.facebook.com/legalnable" target="_blank" rel="noopener noreferrer" >
              <ImFacebook className="icon" />
            </a>
            <a href="https://www.instagram.com/legalnable" target="_blank" rel="noopener noreferrer">
              <BsInstagram className="icon" />
            </a>
            <a href="https://www.linkedin.com/company/legal-n-able" target="_blank" rel="noopener noreferrer" >
              <BsLinkedin className="icon" />
            </a>
          </div>
        </div>

        <div data-aos="fade-up" data-aos-duration="3000" className="footerLinks">
          <span className="linkTitle">
            Information
          </span>
          <li>
            <a href="#">About Us</a>
          </li>
          <li>
            <a href="#">Services</a>
          </li>
          <li>
            <a href="#">Events</a>
          </li>
          <li>
            <a href="#">Privacy Policy</a>
          </li>

        </div>

        <div data-aos="fade-up" data-aos-duration="4000" className="footerLinks">
          <span className="linkTitle">
            Helpful Links
          </span>
          <li>
            <a href="#">FAQs</a>
          </li>
          <li>
            <a href="#">Support</a>
          </li>
          <li>
            <a href="#">Resources</a>
          </li>
          <li>
            <a href="#">Legal Aid</a>
          </li>

        </div>

        <div data-aos="fade-up" data-aos-duration="5000" className="footerLinks">
          <span className="linkTitle">
            Contact Us
          </span>
          <span className="phone">info@legalnable.co.uk</span>
          <span className="phone"> 83 Ducie Street, Manchester, M1 2JQ</span>
        </div>
      </div>
    </div>
  )
}

export default Footer